import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, connect } from 'react-redux';
import { gridDataRowIdsSelector } from '@mui/x-data-grid';
import {
  Avatar,
  Button,
  CardActions,
  CardContent,
  Divider,
  Grid,
  Menu,
  MenuItem,
  Typography,
  Toolbar,
  CssBaseline,
  AppBar,
  Input,
  Select,
  TextField,
  Autocomplete,
  Checkbox,
  Box,
  FormGroup
} from '@mui/material';
import {
  startOfYesterday,
  format,
  addDays,
  endOfDay,
  startOfDay,
  startOfYear,
  startOfMonth,
  endOfMonth,
  endOfYear,
  addMonths,
  addYears,
  startOfWeek,
  endOfWeek,
  isSameDay
} from 'date-fns';
import { DateRangePicker, defaultStaticRanges, createStaticRanges } from 'react-date-range';
import IconButton from '@mui/material/IconButton';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HorizontalRuleTwoToneIcon from '@mui/icons-material/HorizontalRuleTwoTone';
import Switch from '@mui/material/Switch';
import './styleSearch.scss';
import { SET_SEARCH_DATES } from '../../redux/campaign/campaignTypes';
import { fetchCampaignsForAdvertiser, fetchSkanCampaignsForAdvertiser } from '../../redux/advertiser/advertiserActions';
import { ADVERTISERS_ALLOWED_CURRENT_DATE } from '../../config';

const DateSelector = ({
  advertiser_campaign_fetching,
  performanceLoading,
  widzardLoading,
  reportLoading,
  advertiserStartDate,
  StartDate,
  EndDate,
  advertiser_guid,
  sfId,
  isSkan
}) => {
  // helper to safely convert string -> Date
  const parseToDate = (date) => {
    if (!date) return new Date();
    if (date instanceof Date) return date;
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [year, month, day] = date.split('-').map(Number);
      return new Date(year, month - 1, day);
    }

    return new Date(date);
  };
  const [showCalendar, setShowCalendar] = useState(false);
  const [startDate, setStartDate] = useState(parseToDate(StartDate));
  const [endDate, setEndDate] = useState(parseToDate(EndDate));
  const [selectionCount, setSelectionCount] = useState(0);
  const [disable, setDisable] = useState(false);
  const dateRangePickerRef = useRef(null);
  const [minimumDate, setMinimumDate] = useState(new Date(2024, 1, 1));
  const dispatch = useDispatch();
  const isCurrentDateAllowed = advertiser_guid && ADVERTISERS_ALLOWED_CURRENT_DATE.includes(advertiser_guid);

  const defineds = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
    startOfLastThreeMonths: startOfMonth(addMonths(new Date(), -3))
  };

  const getFormattedDate = (date) => {
    return format(date, 'dd/MMM/yy');
  };

  // const getFormattedDateForAPI = (date) => {
  //   return format(date, 'yyyy-MM-dd');
  // };

  const getFormattedDateForAPI = (date) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSelectRange = (ranges) => {
    const count = selectionCount + 1;
    setSelectionCount(count);
    const startDate = ranges.selection.startDate;
    const endDate = ranges.selection.endDate;
    setStartDate(startDate);
    setEndDate(endDate);
    if (count === 2) getFilteredData(startDate, endDate);
  };

  const getFilteredData = (startDate, endDate) => {
    setSelectionCount(0);

    // Get Updated Date Range
    console.log('DateSelector - Updating Redux dates:', {
      startDate: getFormattedDateForAPI(startDate),
      endDate: getFormattedDateForAPI(endDate)
    });

    // Update dates in Redux store first
    dispatch({
      type: SET_SEARCH_DATES,
      payload: {
        startDate: getFormattedDateForAPI(startDate),
        endDate: getFormattedDateForAPI(endDate)
      }
    });

    // // Refetch campaigns with the new date range
    // const advertiserGuid = advertiser_guid || localStorage.getItem('advertiserId');
    // if (advertiserGuid) {
    //   const formattedStartDate = getFormattedDateForAPI(startDate);
    //   const formattedEndDate = getFormattedDateForAPI(endDate);

    //   if (isSkan) {
    //     dispatch(fetchSkanCampaignsForAdvertiser(advertiserGuid, sfId, formattedStartDate, formattedEndDate));
    //   } else {
    //     dispatch(fetchCampaignsForAdvertiser(advertiserGuid, sfId, formattedStartDate, formattedEndDate));
    //   }
    // }
    console.log('DateSelector - Redux dates updated, no campaign fetch triggered');
  };

  const handleApply = () => {
    console.log('DateSelector - Apply button clicked with dates:', {
      startDate: getFormattedDateForAPI(startDate),
      endDate: getFormattedDateForAPI(endDate)
    });
    getFilteredData(startDate, endDate);
    setShowCalendar(false);
    console.log('DateSelector - Apply completed, calendar closed');
  };

  const handleCancel = () => {
    setShowCalendar(false);
  };

  useEffect(() => {
    //console.log('advertiserStartDate', advertiserStartDate);
    setMinimumDate(new Date(advertiserStartDate));
  }, [advertiserStartDate]);

  // useEffect(() => {
  //   if (selectionCount == 0) {
  //     console.log('selectionCount', selectionCount, startDate, endDate);
  //     dispatch({
  //       type: SET_SEARCH_DATES,
  //       payload: {
  //         startDate: getFormattedDateForAPI(startDate),
  //         endDate: getFormattedDateForAPI(endDate)
  //       }
  //     });
  //   }
  // }, []);

  useEffect(() => {
    // console.log(
    //   'advertiser_campaign_fetching',
    //   advertiser_campaign_fetching,
    //   'performanceLoading',
    //   performanceLoading,
    //   'widzardLoading',
    //   widzardLoading,
    //   'reportLoading',
    //   reportLoading
    // );
    // if(advertiser_campaign_fetching==true || performanceLoading==true || widzardLoading==true){
    //     setDisable(true)
    // }
    // else{
    //     setDisable(false)
    // }
  }, [advertiser_campaign_fetching, performanceLoading]);

  const handleOkClick = () => {
    console.log('OK button clicked');
  };

  const staticRanges = createStaticRanges([
    // {
    //   label: 'Today',
    //   range: () => ({
    //     startDate: defineds.startOfToday,
    //     endDate: defineds.endOfToday
    //   })
    // },
    {
      label: 'Yesterday',
      range: () => ({
        startDate: defineds.startOfYesterday,
        endDate: defineds.endOfYesterday
      })
    },
    {
      label: 'This Month',
      range: () => ({
        startDate: defineds.startOfMonth,
        endDate: defineds.endOfYesterday
      })
    },
    {
      label: 'Last Month',
      range: () => ({
        startDate: defineds.startOfLastMonth,
        endDate: defineds.endOfLastMonth
      })
    }
    // {
    //   label: 'Last 3 Months',
    //   range: () => ({
    //     startDate: defineds.startOfLastThreeMonths,
    //     endDate: defineds.endOfLastMonth
    //   })
    // }
  ]);

  return (
    <div className="date-filter">
      {/* <div  onClick={()=>handleLogin1()}>
                        <div>{getFormattedDate(startDate)}-{getFormattedDate(endDate)}</div>
                   
                        <CalendarMonthIcon fontSize="small" className="calendar-logo" />
                    </div> */}
      <div className={disable ? 'calendarDisable' : 'calendarEnable'}>
        <Box
          className="selected-date blue-font flex-row justify-around"
          onClick={() => setShowCalendar(!showCalendar)}
          sx={{ width: '100px', height: '40px' }}
        >
          <div className="selectedDateRangeInputBox">
            {getFormattedDate(startDate)} <HorizontalRuleTwoToneIcon fontSize="medium" sx={{ color: 'rgb(13 13 13)' }} />{' '}
            {getFormattedDate(endDate)}
          </div>
          <CalendarMonthIcon fontSize="medium" className="calendar-logo" sx={{ color: 'rgb(0, 143, 251)' }} />
        </Box>
        <div className={`dateBoxContainer ${showCalendar ? 'show' : 'hide'}`} ref={dateRangePickerRef}>
          <DateRangePicker
            className={`calendar ${showCalendar ? 'show' : 'hide'}`}
            ranges={[
              {
                startDate: startDate,
                endDate: endDate,
                key: 'selection'
              }
            ]}
            calendarFocus="backwards"
            minDate={minimumDate}
            maxDate={isCurrentDateAllowed ? endOfDay(new Date()) : startOfYesterday()}
            onChange={handleSelectRange}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={2}
            direction="horizontal"
            preventSnapRefocus={true}
            inputRanges={[]}
            staticRanges={staticRanges}
          />
          <div className="calendarFooter">
            <Button variant="outlined" onClick={handleCancel}>
              Cancel
            </Button>
            &nbsp;&nbsp;
            <Button variant="outlined" onClick={handleApply}>
              Apply
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    advertiser_campaign_fetching: state.advertiserReducer.advertiser_campaign_fetching,
    performanceLoading: state.campaignReducer.performanceLoading,
    widzardLoading: state.campaignReducer.widzardLoading,
    reportLoading: state.campaignReducer.reportLoading,
    advertiserStartDate: state.advertiserReducer.startDate,
    StartDate: state.campaignReducer.start_date,
    EndDate: state.campaignReducer.end_date,
    advertiser_guid: state.advertiserReducer.advertiser_guid,
    sfId: state.advertiserReducer.sfId,
    isSkan: state.campaignReducer.isSkan
  };
};

export default connect(mapStateToProps)(DateSelector);
